import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { handleApiError } from "@utils/errorHandler";
import { ButtonContainer } from "./MeetingAction.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import AddEditMeetingReport from "../../../AddEditMeetingReport/AddEditMeetingReport";

const MeetingAction = (props) => {
  const { t, data, onRefreshData, updateRefeshStatus, countryId } = props;
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);
  const [isViewMode, setIsViewMode] = useState(false);
  const [isEditMeetingReportPopupVisible, setIsEditMeetingReportPopupVisible] =
    useState(false);
  const handleAnalyticalDisable = () => {
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .delete(`/meetingReports/${data.id}`)
        .then(() => {
          onRefreshData(true);
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const editMeeting = () => {
    setIsEditMeetingReportPopupVisible(true);
  };

  const closeSolutionEditPopup = () => {
    setIsEditMeetingReportPopupVisible(false);
  };
  return (
    <ButtonContainer>
      {data?.canEdit === 1 && (
        <div>
          <Image
            src={editIcon}
            title={t("EDIT")}
            onClick={editMeeting}
            alt={t("EDIT")}
            styles={{ width: "30px", marginLeft: "4px", cursor: "pointer" }}
          />
          <Image
            src={deleteIcon}
            onClick={handleAnalyticalDisable}
            alt={t("DELETE")}
            title={t("DELETE")}
            styles={{ width: "30px", marginLeft: "4px", cursor: "pointer" }}
          />
          {isEditMeetingReportPopupVisible && (
            <AddEditMeetingReport
              id={data.id}
              title={t("EDIT_MEETING_REPORT")}
              onClose={closeSolutionEditPopup}
              isEditMode={isEditMode}
              isViewMode={isViewMode}
              updateRefeshStatus={updateRefeshStatus}
              countryId={countryId}
            />
          )}
        </div>
      )}

      {isConfirmVisible && (
        <WarningPopUp
          title={t("METING_REPORT_CONFIRMATION_BOX_DELETE")}
          message={t("METING_REPORT_CONFIRMATION_BOX_DELETE_CONTENT")}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ButtonContainer>
  );
};

MeetingAction.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(MeetingAction);
